// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__t0kwR {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: 8px;
}

.styles_container__t0kwR::-webkit-scrollbar {
  width: 8px;
}

.styles_container__t0kwR::-webkit-scrollbar-thumb {
  border-radius: 100px;
  height: 8px;
}

.styles_paddingTop__Elykj {
  padding-top: 59px;
}

.styles_containerDark__l1ODe::-webkit-scrollbar-thumb, .styles_wholeContainerDark__ZE65D::-webkit-scrollbar-thumb {
  background-color: #555;
}

.styles_containerWhite__eqCI9::-webkit-scrollbar-thumb, .styles_wholeContainerWhite__wqHSw::-webkit-scrollbar-thumb {
  background-color: #e3e3e3;
}

.styles_containerDark__l1ODe {
  scrollbar-color: #555 transparent !important;
}

.styles_containerWhite__eqCI9 {
  scrollbar-color: #e3e3e3 transparent !important;
}

.styles_wholeContainer__12\\+5u {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: 8px;
}

.styles_wholeContainer__12\\+5u::-webkit-scrollbar {
  width: 8px;
}

.styles_wholeContainer__12\\+5u::-webkit-scrollbar-thumb {
  border-radius: 100px;
  height: 8px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/Main/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EAEA,YAAA;EACA,gBAAA;EAMA,oBAAA;AALF;;AAOE;EAGA,UAAA;AANF;;AASE;EAEA,oBAAA;EACA,WAAA;AAPF;;AAUA;EACE,iBAAA;AAPF;;AASA;EACE,sBAAA;AANF;;AAQA;EACE,yBAAA;AALF;;AAOA;EACE,4CAAA;AAJF;;AAMA;EACE,+CAAA;AAHF;;AAKA;EACE,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAKF,oBAAA;AANA;;AAQA;EAGA,UAAA;AAPA;;AAUA;EAEA,oBAAA;EACA,WAAA;AARA","sourcesContent":[".container {\n  box-sizing: border-box;\n  display:flex;\n  justify-content: space-between;\n  align-items:center;\n  width:100%;\n  height:auto;\n  // margin-top:60px;\n  height: 100%;\n  overflow-y: auto;\n\n\n\n\n  // scrollbar-color: #e3e3e3 transparent;\n  scrollbar-width: 8px;\n  }\n  .container::-webkit-scrollbar {\n  \n  // background: transparent;\n  width: 8px;\n  }\n  \n  .container::-webkit-scrollbar-thumb {\n  // background-color: #e3e3e3;\n  border-radius: 100px;\n  height: 8px;\n  }\n  \n.paddingTop{\n  padding-top: 59px;\n}\n.containerDark::-webkit-scrollbar-thumb,.wholeContainerDark::-webkit-scrollbar-thumb{\n  background-color: #555;\n}\n.containerWhite::-webkit-scrollbar-thumb,.wholeContainerWhite::-webkit-scrollbar-thumb{\n  background-color: #e3e3e3;\n}\n.containerDark{\n  scrollbar-color: #555 transparent !important;\n}\n.containerWhite{\n  scrollbar-color: #e3e3e3 transparent !important;\n}\n.wholeContainer {\n  box-sizing: border-box;\n  display:flex;\n  justify-content: flex-start;\n  align-items:flex-start;\n  width:100%;\n  height:100%;\n  overflow-y: auto;\n\n\n\n// scrollbar-color: #e3e3e3 transparent;\nscrollbar-width: 8px;\n}\n.wholeContainer::-webkit-scrollbar {\n\n// background: transparent;\nwidth: 8px;\n}\n\n.wholeContainer::-webkit-scrollbar-thumb {\n// background-color: #e3e3e3;\nborder-radius: 100px;\nheight: 8px;\n}\n\n\n// .message__containerScrollbarW{\n//   scrollbar-color: #e3e3e3 transparent !important;\n// }\n// .message__containerScrollbarD{\n//   scrollbar-color: #555555 transparent !important;\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__t0kwR`,
	"paddingTop": `styles_paddingTop__Elykj`,
	"containerDark": `styles_containerDark__l1ODe`,
	"wholeContainerDark": `styles_wholeContainerDark__ZE65D`,
	"containerWhite": `styles_containerWhite__eqCI9`,
	"wholeContainerWhite": `styles_wholeContainerWhite__wqHSw`,
	"wholeContainer": `styles_wholeContainer__12+5u`
};
export default ___CSS_LOADER_EXPORT___;
